import { useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { COMPANY } from "@/data/services";
import { LOGO_URL } from "@/lib/api";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Projects", href: "#projects" },
  { label: "Why Us", href: "#why-us" },
  { label: "Contact", href: "#contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="relative z-50 bg-white border-b border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex items-start justify-between py-2">
        <a href="#home" data-testid="nav-logo" className="block overflow-hidden h-64 sm:h-[26rem] lg:h-[36rem]">
          <img src={LOGO_URL} alt="Prowess Services" className="h-72 sm:h-[30rem] lg:h-[42rem] w-auto object-contain object-top" />
        </a>

        <nav className="hidden md:flex items-center gap-7 mt-28 sm:mt-44 lg:mt-56">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-accent transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
          <a
            href={COMPANY.phoneHref}
            data-testid="nav-phone"
            className="flex items-center gap-2 text-sm font-semibold text-slate-900 hover:text-accent transition-colors whitespace-nowrap"
          >
            <Phone className="h-4 w-4" strokeWidth={2} />
            {COMPANY.phoneDisplay}
          </a>
          <a
            href="#book"
            data-testid="nav-book-cta"
            className="bg-accent text-white text-sm font-semibold px-5 py-2.5 rounded-md hover:bg-blue-700 transition-colors whitespace-nowrap"
          >
            Book Service
          </a>
        </nav>

        <button
          className="md:hidden p-2 mt-2 text-slate-900"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-slate-200 px-4 py-4 space-y-3" data-testid="mobile-menu">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={() => setOpen(false)}
              className="block text-slate-700 font-medium py-1"
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
          <a href={COMPANY.phoneHref} className="block text-slate-900 font-semibold py-1">{COMPANY.phoneDisplay}</a>
          <a
            href="#book"
            onClick={() => setOpen(false)}
            className="block text-center bg-accent text-white font-semibold px-5 py-2.5 rounded-md"
            data-testid="mobile-book-cta"
          >
            Book Service
          </a>
        </div>
      )}
    </header>
  );
}
